import React from 'react';
import Slider from 'react-slick';
import { motion } from 'framer-motion';

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  arrows: true,
};

const images = [
  { src: require('../assets/images/project5.webp'), alt: 'slider image 1' },
  { src: require('../assets/images/express.webp'), alt: 'slider image 2' },
  { src: require('../assets/images/verbabg.webp'), alt: 'slider image 3' },
];

const motionVariants = {
  hidden: { opacity: 0, y: -100 }, 
  visible: { opacity: 1, y: 0 },    
  exit: { opacity: 0, y: 100 },     
};

const ImageSlider = () => {
  return (
    <div className="relative mt-2 rounded-3xl overflow-hidden">
      <Slider {...sliderSettings} className="w-full">
        {images.map((image, index) => (
          <div key={index} className="w-full">
            <motion.img
              src={image.src}
              alt={image.alt}
              style={{ border: 'none', outline: 'none' ,pointerEvents:'none'}} 
              className="w-full h-auto object-cover rounded-md"
              initial="hidden"
              animate="visible"
              exit="exit"
              variants={motionVariants}
              transition={{ duration: 1, ease: "easeInOut" }}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ImageSlider;
